window.addEventListener('DOMContentLoaded', () => {
  console.log('Custom product image script loaded ✅');

  const productMedia = document.getElementById('product-media');
  const newImgContainer = document.createElement('div');
  newImgContainer.style.width = '100%';
  newImgContainer.style.display = 'flex';
  const mainImg = document.createElement('img');
  mainImg.style.cursor = 'default';
  newImgContainer.appendChild(mainImg);
  productMedia.after(newImgContainer);
  productMedia.style.display = 'none';

  const thumbs = Array.from(document.querySelectorAll('.product-thumbnail-wrap img'));

  // Thumbnail click logic remains exactly the same
  thumbs.forEach((thumb) => {
    const thumbId = thumb.id.replace('FeaturedImage-product-', '');
    const highResImage = document.querySelector(`[data-media-id="media-template-product-${thumbId}"] img`);
    thumb.style.cursor = 'pointer';
    thumb.addEventListener('click', () => {
      mainImg.src = highResImage.src;
      mainImg.alt = highResImage.alt;
      console.log('Thumbnail clicked, main image updated');
    });
  });

  // Variant swatch click logic updated: compare swatch value (variant name) to image src or alt
  const swatches = Array.from(document.querySelectorAll('.form-field__swatch-options input[type="radio"]'));
  swatches.forEach((swatch) => {
    swatch.addEventListener('change', () => {
      console.log('Swatch selected:', swatch.value);

// Find the first thumbnail whose filename or alt matches the variant
const matchingThumb = thumbs.find(t => {
  const filename = (t.getAttribute('src') || '').toLowerCase();
  const altText = (t.getAttribute('alt') || '').toLowerCase();
  const variantName = swatch.value.toLowerCase().trim();

  // Normalize everything: remove underscores, dashes, spaces
  const normalize = str => str.replace(/[_\-\s]/g, '');

  const normalizedVariant = normalize(variantName);
  const normalizedFilename = normalize(filename);
  const normalizedAlt = normalize(altText);

  return normalizedFilename.includes(normalizedVariant) ||
         normalizedAlt.includes(normalizedVariant);
});


      if (matchingThumb) {
        const thumbId = matchingThumb.id.replace('FeaturedImage-product-', '');
        const highResImage = document.querySelector(`[data-media-id="media-template-product-${thumbId}"] img`);
        if (highResImage) {
          mainImg.src = highResImage.src;
          mainImg.alt = highResImage.alt;
          console.log('Main image updated for variant:', swatch.value);
        }
      } else {
        console.warn('No matching thumbnail found for variant:', swatch.value);
      }
    });
  });

  // Set initial main image based on checked swatch
  const checkedSwatch = swatches.find(s => s.checked);
  let initialThumb = thumbs[0];
  if (checkedSwatch) {
    const matchingThumb = thumbs.find(t => {
      const filename = t.getAttribute('src') || '';
      const altText = t.getAttribute('alt') || '';
      const variantName = checkedSwatch.value.toLowerCase();
      return filename.toLowerCase().includes(variantName) || altText.toLowerCase().includes(variantName);
    });
    if (matchingThumb) initialThumb = matchingThumb;
  }

  if (initialThumb) {
    const thumbId = initialThumb.id.replace('FeaturedImage-product-', '');
    const highResImage = document.querySelector(`[data-media-id="media-template-product-${thumbId}"] img`);
    mainImg.src = highResImage.getAttribute('data-src') || highResImage.src;
    mainImg.alt = highResImage.alt || '';
    console.log('Initial main image set on page load');
  }
});
